export default __webpack_public_path__ + "static/media/teslaclone.65071580.webp";